import { FC, memo } from 'react';
import { isEmpty } from 'lodash';
// Import Hooks
import useCountdownTimer from 'hooks/UseCountdownTimer';

interface Props {
    /* Target date in the UTC standard format, e.g. 2026-08-25T18:00:00Z */
    date: Nilable<string>;
    /* Timezone of the target date as a decimal offset, e.g. 4, -5.5 */
    timeZone?: Nilable<number>;
    /* Rendered once the target date is reached */
    expiredText?: string;
    className?: string;
}

const Countdown: FC<Props> = ({ date, timeZone, expiredText, className }) => {
    const { remainingTime } = useCountdownTimer({ date, timeZone, expiredText });

    if (isEmpty(remainingTime)) {
        return null;
    }

    return <span className={className}>{remainingTime}</span>;
};

export default memo(Countdown);
